<template>
  <svg width="32" height="32" viewBox="0 0 32 32">
    <path
      d="M16.006 28C22.566 28 28 22.566 28 15.994 28 9.434 22.554 4 15.994 4 9.434 4 4 9.434 4 15.994 4 22.566 9.446 28 16.006 28zm7.315-5.36c-1.2-1.398-3.861-2.636-7.315-2.636-3.453 0-6.114 1.238-7.315 2.624-1.584-1.745-2.537-4.072-2.537-6.634 0-5.471 4.369-9.865 9.84-9.865a9.854 9.854 0 0 1 9.877 9.865c0 2.562-.965 4.889-2.55 6.647zm-3.292-9.023c0-2.364-1.782-4.332-4.023-4.332-2.253 0-4.035 1.968-4.023 4.332.013 2.513 1.758 4.407 4.023 4.42 2.253.024 4.023-1.907 4.023-4.42z"
      fill="#000"
      fill-rule="evenodd"
    />
  </svg>
</template>
